<template>
  <div class="ion-margin-top report-component">
    <!-- START Number item -->
    <ion-item>
      <ion-label v-if="placeholders && placeholders[0]" position="floating">
        {{ placeholders[0] }}
      </ion-label>
      <ion-label v-else position="floating">Saisir...</ion-label>

      <ion-input
        :disabled="disabled"
        type="number"
        step="0.01"
        :value="value"
        @ionChange="$emit('update:value', $event.detail.value)"
      ></ion-input>
    </ion-item>
  </div>
</template>

<script>
import { IonItem, IonInput, IonLabel } from '@ionic/vue';

export default {
  name: 'Number',

  components: {
    IonItem,
    IonLabel,
    IonInput,
  },

  props: {
    title: String,
    placeholders: Array,
    value: String,
    disabled: Boolean,
  },

  emits: ['update:value'],
};
</script>
